// PartCPage10.jsx - Part C Page 10 for HPC Report (Pixel-perfect redesign - Post-inquiry reflections with stick figure and arrows)
import React from 'react';

const PartCPage10 = ({ data }) => {
  const teacherFields = data?.teacher_fields || {};
  const studentFields = data?.student_fields || {};

  const reflectionQuestions = [
    { label: 'What did I learn in this\nproblem-based inquiry?', value: studentFields.what_learned },
    { label: 'What was the most enjoyable\npart of the inquiry?', value: studentFields.most_enjoyable },
    { label: 'Three strengths I demonstrated\nin this inquiry', value: studentFields.three_strengths },
    { label: 'What was the least enjoyable\npart of the inquiry?', value: studentFields.least_enjoyable },
    { label: 'Three areas of improvement I identified\nthis inquiry', value: studentFields.areas_improvement },
    { label: 'Some questions I still have...', value: studentFields.questions_still_have }
  ];

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Top-right corner */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Header */}
      <div style={{
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '15px',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '10px'
      }}>
        Post-inquiry reflections
      </div>

      {/* Teacher Comments */}
      <div style={{
        backgroundColor: '#FFE5D5',
        padding: '12px',
        marginBottom: '15px'
      }}>
        <div style={{ fontWeight: 'bold', fontSize: '10px', marginBottom: '8px' }}>
          Final comments by the teacher (if any):
        </div>
        <div style={{
          padding: '10px',
          minHeight: '100px',
          fontSize: '10px',
          lineHeight: '1.4',
          backgroundColor: '#FFE5D5'
        }}>
          {teacherFields.final_comments || ''}
        </div>
      </div>

      {/* Stick figure with speech bubble */}
      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px', gap: '10px' }}>
        {/* Stick figure */}
        <svg width="50" height="70" viewBox="0 0 50 70" style={{ flexShrink: 0 }}>
          {/* Head */}
          <circle cx="25" cy="12" r="10" stroke="black" strokeWidth="2" fill="white" />
          {/* Body */}
          <line x1="25" y1="22" x2="25" y2="42" stroke="black" strokeWidth="2" />
          {/* Arms */}
          <line x1="25" y1="30" x2="12" y2="38" stroke="black" strokeWidth="2" />
          <line x1="25" y1="30" x2="38" y2="38" stroke="black" strokeWidth="2" />
          {/* Legs */}
          <line x1="25" y1="42" x2="15" y2="60" stroke="black" strokeWidth="2" />
          <line x1="25" y1="42" x2="35" y2="60" stroke="black" strokeWidth="2" />
        </svg>

        {/* Speech bubble */}
        <div style={{ position: 'relative', marginTop: '-10px' }}>
          <div style={{
            backgroundColor: 'white',
            border: '2px solid black',
            borderRadius: '10px',
            padding: '8px 12px',
            fontSize: '8px',
            lineHeight: '1.3',
            maxWidth: '120px',
            textAlign: 'center',
            fontWeight: 'bold'
          }}>
            Think about how you did in this research task.
            {/* Speech bubble pointer */}
            <div style={{
              position: 'absolute',
              bottom: '50%',
              left: '-10px',
              width: 0,
              height: 0,
              borderTop: '7px solid transparent',
              borderBottom: '7px solid transparent',
              borderRight: '10px solid black'
            }} />
            <div style={{
              position: 'absolute',
              bottom: '50%',
              left: '-6px',
              width: 0,
              height: 0,
              borderTop: '5px solid transparent',
              borderBottom: '5px solid transparent',
              borderRight: '8px solid white'
            }} />
          </div>
        </div>
      </div>

      {/* Learner Reflection */}
      <div style={{
        backgroundColor: '#4A90A4',
        color: 'white',
        padding: '8px',
        fontWeight: 'bold',
        fontSize: '12px',
        textAlign: 'center',
        marginBottom: '10px'
      }}>
        Learner Reflection
      </div>

      {/* Reflection boxes with arrows */}
      <div style={{ position: 'relative' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', position: 'relative' }}>
          {reflectionQuestions.map((item, index) => (
            <div key={index} style={{
              backgroundColor: '#B3D9E8',
              padding: '10px',
              borderRadius: '4px',
              minHeight: '100px',
              position: 'relative'
            }}>
              <div style={{ fontWeight: 'bold', fontSize: '9px', marginBottom: '6px', textAlign: 'center' }}>
                {item.label.split('\n').map((line, i) => <div key={i}>{line}</div>)}
              </div>
              <div style={{
                fontSize: '9px',
                lineHeight: '1.3',
                minHeight: '50px'
              }}>
                {item.value || ''}
              </div>
            </div>
          ))}

          {/* Arrows - positioned absolutely */}
          <svg style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
          }}>
            {/* Arrow from box 0 to box 2 (left column) */}
            <path d="M 10 130 Q 5 160, 10 190" stroke="#4A90A4" strokeWidth="3" fill="none" markerEnd="url(#arrowhead)" />
            {/* Arrow from box 2 to box 4 (left column) */}
            <path d="M 10 310 Q 5 340, 10 370" stroke="#4A90A4" strokeWidth="3" fill="none" markerEnd="url(#arrowhead)" />
            {/* Arrow from box 1 to box 3 (right column) */}
            <path d="M 380 130 Q 390 160, 380 190" stroke="#4A90A4" strokeWidth="3" fill="none" markerEnd="url(#arrowhead)" />
            {/* Arrow from box 3 to box 5 (right column) */}
            <path d="M 380 310 Q 390 340, 380 370" stroke="#4A90A4" strokeWidth="3" fill="none" markerEnd="url(#arrowhead)" />

            <defs>
              <marker id="arrowhead" markerWidth="10" markerHeight="10" refX="5" refY="5" orient="auto">
                <polygon points="0 0, 10 5, 0 10" fill="#4A90A4" />
              </marker>
            </defs>
          </svg>
        </div>

        {/* Last question full width */}
        <div style={{
          backgroundColor: '#B3D9E8',
          padding: '10px',
          borderRadius: '4px',
          minHeight: '80px',
          marginTop: '12px'
        }}>
          <div style={{ fontWeight: 'bold', fontSize: '9px', marginBottom: '6px', textAlign: 'center' }}>
            How could your teacher modify this inquiry to make it more interesting?
          </div>
          <div style={{
            fontSize: '9px',
            lineHeight: '1.3',
            minHeight: '40px'
          }}>
            {studentFields.teacher_modify || ''}
          </div>
        </div>
      </div>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '11px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        28
      </div>

      {/* Bottom corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartCPage10;
